import { render, staticRenderFns } from "./SendEgiftPanelRecipients.vue?vue&type=template&id=23e49420&scoped=true"
import script from "./SendEgiftPanelRecipients.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelRecipients.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelRecipients.vue?vue&type=style&index=0&id=23e49420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e49420",
  null
  
)

export default component.exports